import React from 'react';
import { formatPrice, decayColor, discountColor } from '../utils/formatters';

export default function PriceTag({ currentPrice, ceilingPrice, daysUntilStay, decayPercent, showBar = true }) {
  const colorClass   = decayColor(decayPercent);
  const fillPct      = Math.round(decayPercent * 100);
  const hasDiscount  = currentPrice < ceilingPrice;
  const discountPct  = hasDiscount
    ? Math.round((ceilingPrice - currentPrice) / ceilingPrice * 100)
    : 0;

  return (
    <div className={`price-tag ${colorClass}`}>
      {hasDiscount && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.15rem', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 'var(--text-base)', color: 'var(--border-strong)', textDecoration: 'line-through', fontWeight: 400 }}>
            {formatPrice(ceilingPrice)}
          </span>
          <span className={`discount-badge ${discountColor(discountPct)}`}>
            {discountPct}% off
          </span>
        </div>
      )}

      <div className="current-price">{formatPrice(currentPrice)}</div>

      {showBar && (
        <div className="decay-bar-wrap">
          <div className="decay-bar-track">
            <div className="decay-bar-fill" style={{ width: `${fillPct}%` }} />
          </div>
          <div className="decay-label">
            {daysUntilStay > 0
              ? `${daysUntilStay} day${daysUntilStay !== 1 ? 's' : ''} until check-in`
              : 'Check-in today'}
          </div>
        </div>
      )}
    </div>
  );
}
